import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  id: [
    {...makeRule('请输入正确的图片流转配置ID', 'integer', 'blur', false), min: 1},
  ],
  batch_id: [
    {...makeRule('请输入正确的批次ID', 'integer', 'blur', false), min: 1},
  ],
}

export let formRules = {
  name: [
    {...makeRule('请输入图片流转配置名称', 'string')},
    {...makeRule('请输入至少2个字符', 'string'), min: 2},
  ],
  customer_id: [
    {...makeRule('请选择客户', 'integer'), min: 1},
  ],
  project_id: [
    {...makeRule('请选择项目', 'integer'), min: 1},
  ],
  batch_id: [
    {...makeRule('请选择批次', 'integer'), min: 1},
  ],
  step_template_id: [
    {...makeRule('请选择分布模板', 'integer'), min: 1},
  ],
  step_template_question_ids: [
    {...makeRule('请选择分布模板问题', 'array'), min: 1},
  ],
  model_id: [
    {...makeRule('请选择模型', 'integer'), min: 1},
  ],
}



// WEBPACK FOOTER //
// ./src/views/img-flow-config/img-flow-config.rules.js